import {makeStyles} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  buttonStyle: {
    marginTop: theme.spacing(1),
    textTransform: 'none',
  },
  cardStyle: {
    marginRight: 30,
    marginBottom: 30,
    minWidth: 200,
    maxWidth: 200,
  },
  buttonDisabled: {},
  button: {
    '&$buttonDisabled': {
      color: theme.palette.grey[900],
    },
  },
  nameStyle: {
    fontWeight: 500,
    fontSize: 15,
    marginRight: 5,
  },
  labelStyle: {
    fontSize: 12,
    color: '#9e9e9e',
    fontWeight: 'fontWeightLight',
    marginRight: 5,
  },
  numberStyle: {
    fontSize: 10,
    color: '#9e9e9e',
    fontWeight: 'fontWeightLight',
    marginTop: -15,
  },
  truncate: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: 5,
  },
}))

export default useStyles
